import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector, useDispatch } from 'react-redux';

import './FeedbackModalWrapper.css';

import { ModalWrapper } from '~ui-kit';

import { setShow } from '../ducks';

const FeedbackModalWrapper = props => {
  const dispatch = useDispatch();
  const { name, title, children, noButtons } = props;

  const show = useSelector(state => state.modals.show);

  const onHide = () => dispatch(setShow(null));

  return (
    <Modal
      show={show === name}
      onHide={onHide}
      dialogClassName={
        name === 'EXTERNAL_FEEDBACK' ? 'modal-external' : 'modal-custom'
      }
    >
      <Modal.Body>
        {name === 'EXTERNAL_FEEDBACK' ? (
          <div>{show && children}</div>
        ) : (
          <ModalWrapper
            {...props}
            close={onHide}
            title={title}
            backText="Takaisin"
            backOnClick={!noButtons && onHide}
            confirmText="Lähetä"
          >
            {show && children}
          </ModalWrapper>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default FeedbackModalWrapper;
